module.exports = __webpack_public_path__ + "img/menu-off_04.12a6dcc6.png";